export default {
    'restore-all-samples': 'استعادة كافة المواد',
    'samples-summary': 'ملخص المواد',
    'remaining-samples': 'المواد المتبقية',
    'from-the-selected-medical-rep-to-her-/-his-line-manager': 'من الممثل المختار إلى مديره المباشر'
}